if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    addUrlParam(search, key) {
      var params = new URLSearchParams(search);
      params.set(key, this.i); // Устанавливаем номер страницы
      return '?' + params.toString();
    }

    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }

    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }

    loadProducts() {
      let base = this,
          currentUrl = document.location.pathname + document.location.search,
          newUrl = document.location.pathname + base.addUrlParam(document.location.search, 'page');

      if (base.getAttribute('loading')) {
        return;
      }

      base.i++; // Увеличиваем номер страницы
      base.setAttribute('loading', true);

      fetch(newUrl)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, newUrl);
          
          // Обновляем URL без перезагрузки страницы
          history.pushState(null, '', newUrl);

          dispatchCustomEvent('pagination:page-changed', { url: newUrl });
        });
    }

    renderProducts(html, url) {
      let base = this,
          grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }

      let products = grid_to_replace.querySelectorAll('.column');
      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }

      if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            if (typeof StampedFn.loadBadges !== "undefined") {
              StampedFn.loadBadges();
            }
          }
        });
      } else {
        base.removeAttribute('loading');
        if (window.StampedFn && typeof StampedFn.loadBadges !== "undefined") {
    StampedFn.loadBadges();
}
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
